import { formatNumber } from '@angular/common';

import { CustomFormatter } from '@messageformat/core';

import { isNumber } from '@kros-sk/shared/utils-fn/number';
import { isString } from '@kros-sk/utils-fn/string';

export function numberFormatter(): CustomFormatter {
  return (value: unknown, locale: string, format: string | null) => {
    let numberValue: number | null;

    if (value === null || value === undefined) {
      value = 0;
    }

    if (isNumber(value)) {
      numberValue = value;
    } else if (isString(value)) {
      numberValue = parseFloat(value);
      numberValue = isNaN(numberValue) ? null : numberValue;
    } else {
      numberValue = null;
    }

    if (numberValue == null) {
      throw new Error('fmtNumber: Invalid number value', { cause: value });
    }

    return formatNumber(numberValue, locale, format || '1.2-2');
  };
}
